export default "__VITE_ASSET__X5gpwd0G__"